'use client';

import type React from 'react';

import { Inter } from 'next/font/google';
import ErrorBoundary from '@/components/ErrorBoundary';
import '@/styles/globals.css';
import { AppProvider } from '@/contexts/AppProvider';
import { GoogleAnalytics } from '@/components/analytics/GoogleAnalytics';
import { GoogleMaps } from '@/components/GoogleMaps';
import { ChunkErrorHandler } from '@/components/ChunkErrorHandler';

const inter = Inter({
  subsets: ['latin'],
  variable: '--font-sans',
});

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <GoogleAnalytics />
        <GoogleMaps />
      </head>
      <body className={`${inter.variable} font-sans antialiased`}>
        <ChunkErrorHandler />
        <ErrorBoundary>
          <AppProvider>{children}</AppProvider>
        </ErrorBoundary>
      </body>
    </html>
  );
}
